import React, {useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";

import "../App.scss"
import "../styles/search.scss"

export default function SearchBar({search, setSearch, searchRef, setTags, setCurrentPage, setHiddenFilters}) {

  const handleChange = (e) => {
    setSearch(e.target.value);
    // console.log("recibiendo: " + e.target.value);

    // On changing to NEW search, we must RESET the page-counter (from other previos results)
    setCurrentPage(0);
    // RESET FILTERS as the current DOESN'T APPLY
    setTags({});
    setHiddenFilters([]);

  };

  // useEffect(() => {
  //   console.log("Search inside USEFECT: " + search);
  //
  // }, [search]);

  return (
    <div className="search">
      <FontAwesomeIcon icon={faMagnifyingGlass} size="lg"/>
      <input
        id="searchBar" key="search_input"
        placeholder={search?.length >0 ? '' : "Introdueix les paraules de cerca"}
        onChange={(e) => handleChange(e)}
        defaultValue={search?.length >0 ? search : ""}
        ref={searchRef}
      />
    </div>
  );
}